import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Box, Container, Tab, Tabs } from "@mui/material";

import { RoutesConfig } from "../../configs/Routes";
import { useAuth } from "../../contexts/AuthContext";

const defaultPage: string = "/jobs";

const Navigation: React.FC = () => {
  const { currentUser } = useAuth();
  const [selectedPage, setSelectedPage] = React.useState<string | boolean>(defaultPage);
  const location = useLocation();
  const navigate = useNavigate();

  const handleTabClick = (_event: React.MouseEvent<HTMLDivElement, MouseEvent>, href: string) => {
    setSelectedPage(href);
    navigate(href);
  };

  const filteredRoutes = useMemo(
    () =>
      RoutesConfig.filter(
        ({ navigationItem, auth }) =>
          // show navigation items that are either public or accessible to the current user's role
          navigationItem && (!auth || auth.requiredRoles.includes(currentUser.role)),
      ),
    [currentUser.role],
  );

  React.useEffect(() => {
    let page = `/${location.pathname.split("/")[1]}`;
    if (page === "/") {
      page = defaultPage;
    }
    if (RoutesConfig.find((item) => item.path === page)) {
      setSelectedPage(page);
    }
  }, [location.pathname]);

  return (
    <Container maxWidth={false}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", paddingTop: "8px" }}>
        <Tabs value={selectedPage} variant="scrollable" scrollButtons="auto">
          {filteredRoutes.map(({ navigationItem, path }, index) => (
            <Tab
              key={index}
              label={navigationItem?.label}
              value={path}
              onClick={(e) => handleTabClick(e, path)}
            />
          ))}
        </Tabs>
      </Box>
    </Container>
  );
};

export default Navigation;
